"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthsOfYearPicker = void 0;
const toggle_1 = __importDefault(require("@opsbase/lib-general/utils/toggle"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const range_1 = __importDefault(require("lodash/range"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importDefault(require("react"));
const MonthsOfYearPicker = (props) => {
    const { monthsOfYear, onChange } = props;
    const numMonths = monthsOfYear === null || monthsOfYear === void 0 ? void 0 : monthsOfYear.length;
    const handleClickMonth = (0, useCallforward_1.default)(v => () => {
        onChange((0, toggle_1.default)(monthsOfYear, v));
    }, [monthsOfYear, onChange]);
    return (react_1.default.createElement(Vertical_1.default, null, (0, range_1.default)(2).map(w => (react_1.default.createElement(Horizontal_1.default, { key: `row-${w}` }, (0, range_1.default)(6)
        .map(d => w * 6 + d + 1)
        .map(n => {
        const isSelected = monthsOfYear.indexOf(n) >= 0;
        return (react_1.default.createElement(Button_1.default, { key: `month-of-year-${n}`, small: true, bordered: true, margin: 1, noEvents: isSelected && numMonths <= 1, color: isSelected ? lib_palette_1.default.secondary : lib_palette_1.default.White, onClick: handleClickMonth(n), label: moment_timezone_1.default.monthsShort(n - 1) }));
    }))))));
};
exports.MonthsOfYearPicker = MonthsOfYearPicker;
exports.default = exports.MonthsOfYearPicker;
